// extracted by mini-css-extract-plugin
module.exports = {"base":"_2zgAveSYT0YaQ2tfrcCu96","background":"_3qXn-0VXDTdYWLTW3fN2Hd","content":"_2rXfTlb7NhrNGIGG1moxkd"};